import {
    GetClassGradeList,
    DeleteClassGrade,
    PostClassGrade,
    GetClassGrade,
    UpdateClassGrade,
    ChangeClassGradeStatus,
} from '@src/services/classgrade'
import { GetStudentList, GetStudent } from '@src/services/student'
import { getSavedState } from '@src/utils/localStorage'
export const state = {
    classgradeList: [],
    studentList: [],
    studentFromForm: null,
}

export const getters = {
    totalList(state) {
        return state.classgradeList.data
            ? state.classgradeList.data.totalItemCount
            : 0
    },
    maxClassGrade(state) {
        return state.classgradeList.data ? state.classgradeList.data.max : 0
    },
    currentClassGrade(state) {
        return state.classgradeList.data ? state.classgradeList.data.current : 0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.classgradeList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((classgrade) => {
            state.classgradeList.data.items.push(classgrade)
        })
    },
    SET_STUDENT(state, student) {
        state.studentFromForm = student
    },
    SET_STUDENTS_LIST(state, newList) {
        state.studentList = newList
    },
    SET_STATUS(state, classgradeList) {
        state.classgradeList.data.items.find(({ publicId }) => {
            return publicId === classgradeList.publicId
        }).status = classgradeList.status
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetClassGradeList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetClassGradeList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async deleteClassGrade({ dispatch }, classgrade) {
        const resp = await DeleteClassGrade(classgrade)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async createClassGrade({ _ }, classgradeMember) {
        classgradeMember.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await PostClassGrade(classgradeMember)
        return resp
    },
    async setClassGradeForm({ _ }, classgrade) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetClassGrade(classgrade, locationPublicId)
        return resp
    },
    async updateClassGrade({ _ }, classgrade) {
        classgrade.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await UpdateClassGrade(classgrade)
        return resp
    },
    async setStudentFromClass({ commit }, student) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudent(student, locationPublicId)
        commit('SET_STUDENT', resp.data.data)
        return resp
    },
    async getStudentsList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudentList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_STUDENTS_LIST', resp.data.data.list.items)
        }
    },
    removeStudentFromForm({ commit }) {
        commit('SET_STUDENT', null)
    },
    async setStatus({ commit }, parameters) {
        const resp = await ChangeClassGradeStatus(parameters)
        if (resp.status === 200) {
            commit('SET_STATUS', parameters)
        }
        return resp
    },
}
